import { render, staticRenderFns } from "./MainLedgerIzvodPregled.vue?vue&type=template&id=0d8ed60c&scoped=true"
import script from "./MainLedgerIzvodPregled.vue?vue&type=script&lang=js"
export * from "./MainLedgerIzvodPregled.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerIzvodPregled.vue?vue&type=style&index=0&id=0d8ed60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8ed60c",
  null
  
)

export default component.exports